import { render, staticRenderFns } from "./bookingData.vue?vue&type=template&id=04b307b8&scoped=true"
import script from "./bookingData.vue?vue&type=script&lang=js"
export * from "./bookingData.vue?vue&type=script&lang=js"
import style0 from "./bookingData.vue?vue&type=style&index=0&id=04b307b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b307b8",
  null
  
)

export default component.exports